
import React, { useEffect, useState } from 'react';
import ApiService from 'services';
import { Table, Row, Col } from 'react-bootstrap';
import TCABreadCrumb from 'components/breadcrumb';
import { slugify } from 'utils/misc';
function getIndex(index) {
    return index + 1;
}
export default function AllTournaments() {

    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ApiService.getTournaments();
                setData(response);
                //console.log(response);
            } catch (error) {
                // Handle error
            }
        };

        fetchData();
    }, []);
    const breadCrumbData = [
        {
            title: "All Tournaments",

        }
    ];
    return (
        <div>
            <Row>
                <Col>
                    <TCABreadCrumb breadCrumbData={breadCrumbData} />
                    <h1>Tournaments</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Tournament Name</th>

                            </tr>
                        </thead>
                        <tbody>
                            {data.sort(function (a, b) {
                                // return a negative number if a < b, 0 if a == b, or a positive number if a > b
                                return (a.StartDate == b.StartDate ? 0 : (a.StartDate > b.StartDate ? -1 : 1))
                            }).map((oneTournament, index) => {
                                return <tr key={index}>
                                    <td>{getIndex(index)}.</td>
                                    <td> <a href={"/tournaments/" + slugify(oneTournament.Name) + "-" +  oneTournament.Id} >{oneTournament.Name}</a></td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    );
}